export default {
	userProfile: 'users',
	useFirestoreForProfile: true,
};
